module.exports = __webpack_public_path__ + "img/aai.5d063340.png";